import { render } from "./LogInstallUpdatesComponent.vue?vue&type=template&id=5bf925f4&scoped=true"
import script from "./LogInstallUpdatesComponent.vue?vue&type=script&lang=js"
export * from "./LogInstallUpdatesComponent.vue?vue&type=script&lang=js"

import "./LogInstallUpdatesComponent.vue?vue&type=style&index=0&id=5bf925f4&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf925f4"]])

export default __exports__